import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/login" element={<Login data-id="element-5" />} data-id="element-4" />
        <Route path="/register" element={<Register data-id="element-7" />} data-id="element-6" />
        <Route path="/dashboard/*" element={<Dashboard data-id="element-9" />} data-id="element-8" />
      </Routes>
    </BrowserRouter>;
}